import { Button, DropdownSelect, Input } from '@components/common';
import { Plus, Search } from 'lucide-react';
import React from 'react';
import { AccountType } from '../../../../types/accounting';
import { AccountingPageInfoButton } from '../AccountingHelp';
import { ACCOUNT_TYPE_OPTIONS } from './accountForm';

interface AccountsToolbarProps {
  searchQuery: string;
  typeFilter: 'all' | AccountType;
  isRefreshing: boolean;
  onSearchChange: (value: string) => void;
  onTypeFilterChange: (value: 'all' | AccountType) => void;
  onRefresh: () => void;
  onCreate: () => void;
}

export function AccountsToolbar({
  searchQuery,
  typeFilter,
  isRefreshing,
  onSearchChange,
  onTypeFilterChange,
  onRefresh,
  onCreate,
}: AccountsToolbarProps) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h2 className="text-lg font-semibold text-black">
            Chart of Accounts
          </h2>
          <p className="mt-1 text-sm text-gray-600">
            Create and maintain the accounts used by your accounting engine.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
          <AccountingPageInfoButton page="chart-of-accounts" />
          <div className="relative w-full sm:w-80">
            <Search
              className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              size={16}
            />
            <Input
              value={searchQuery}
              onChange={(value) => onSearchChange(String(value))}
              placeholder="Search by code, name, or subtype"
              className="pl-10"
            />
          </div>
          <DropdownSelect
            value={typeFilter}
            onChange={(v) => onTypeFilterChange(v as 'all' | AccountType)}
            options={[
              { value: 'all', label: 'All types' },
              ...ACCOUNT_TYPE_OPTIONS,
            ]}
          />
          <Button
            variant="outline"
            onClick={onRefresh}
            isLoading={isRefreshing}
          >
            Refresh
          </Button>
          <Button onClick={onCreate}>
            <Plus size={16} />
            Create
          </Button>
        </div>
      </div>
    </div>
  );
}
